(function() {
  'use strict';

  angular.module('ringbaPortal').directive('highlightNewIvrNode', highlightNewIvrNode);

  function highlightNewIvrNode(

  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      scope: {
        nodeToHighlight: '<',
        highlightOn: '@'
      },
      controller: HighlightNewIvrNodeController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

    function HighlightNewIvrNodeController(
      // $element is the element with which the controller is attached.
      // In this case, it is the header of the node which has class '.panel-heading'.
      $element,
      $timeout
    ) {
      'ngInject';

      const vm = this;

      vm.$onChanges = onChanges;

      function onChanges() {
        if (vm.nodeToHighlight[vm.highlightOn]) {
          $timeout(function () {
            vm.nodeToHighlight[vm.highlightOn] = false;
            _scrollToNode();
            $element.find('.panel-heading').addClass('flicker flicker-new-ivr-node');
            _removeFlickerClass();
          }, 0);
        }
      }

      function _scrollToNode() {
        const $treeCanvasWrapperElement = $('.tree-canvas-wrapper'),
          canvasWrapperScrollTop = $treeCanvasWrapperElement.scrollTop(),
          canvasWrapperScrollLeft = $treeCanvasWrapperElement.scrollLeft();

        const nodePositionTop = $element.position().top,
          nodePositionLeft = $element.position().left, // position() gives position of the element relative to the parent element
          scrollTopNew = nodePositionTop - 10,
          scrollLeftNew = nodePositionLeft - 200,
          isElementInViewHorizontally = (canvasWrapperScrollLeft > scrollTopNew) ||
              ((nodePositionLeft + $element.outerWidth() + 10) > ($treeCanvasWrapperElement.width() + canvasWrapperScrollLeft)),
          isElementInViewVertically = (canvasWrapperScrollTop > scrollTopNew) ||
              ((nodePositionTop + $element.outerHeight() + 10) > ($treeCanvasWrapperElement.height() + canvasWrapperScrollTop));

        _animateScroll($treeCanvasWrapperElement, isElementInViewVertically ? scrollTopNew : canvasWrapperScrollTop, isElementInViewHorizontally ? scrollLeftNew : canvasWrapperScrollLeft);
      }

      function _animateScroll($elementToScroll, newScrollTop, newScrollLeft) {
        $elementToScroll.animate({
          scrollTop: newScrollTop,
          scrollLeft: newScrollLeft
        }, 200);
      }

      function _removeFlickerClass() {
        $timeout(function () {
          $element.find('.panel-heading').removeClass('flicker flicker-new-ivr-node');
        }, 1005);
      }

    }
  }

})();
